import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import Reviews from './Reviews';
import Develop from './Develop';
import { Contactformnew } from './ContactfromNew';

function Support() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='websitedevelopkrishnagar'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Maintenance & Support</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 className='linetext'><b>Ongoing support to ensure your digital assets run smoothly and stay up to date.</b></h1>
                                <p className='mb-2' style={{ color: "grey" }}> We understand that post-launch care is crucial for sustained performance and long-term success.</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Regular Website Updates & Bug Fixes</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg>  Proactive Security Monitoring</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg>  Technical Consultation & Strategy</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Uptime & Health Maintenance</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Performance Optimization</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Content & Feature Updates</p>


                            </div>
                            <div className="col-md-5">
                            <Contactformnew/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <br />
                    <h1 className=' mb-0'><b>Maintenance & Support</b></h1>
                    <div className="row">
                        <div className="col-md-5 mb-0">
                            <hr className='mb-2 mb-3' />
                        </div>
                    </div>

                    <h5 style={{ color: "#909090" }} className='websitedevelopment mb-3'>
                        Regular audits and improvements to ensure your website loads fast and offers a seamless experience across all devices.</h5>
                    <h5 ><b>🔹 Regular Website Updates & Bug Fixes </b></h5>
                    <p className='websitedevelopment mb-2'> Monthly or on-demand updates to core systems, plugins, and themes.</p>
                    <p className='mb-3'>Integration of user feedback and analytics-based improvements to optimize engagement.</p>
                    <h5><b> 🔹 Proactive Security Monitoring</b></h5>
                    <p className='mb-2'>Timely application of security patches, firewall rules, and SSL certificate updates.</p>
                    <p className='mb-3'> Real-time threat alerts and automated protective actions to protect against hacks and DDoS attacks.</p>

                    <h5 className='mb-2'><b> 🔹 Technical Consultation & Strategy</b></h5>
                    <p className='mb-2'><small>Personalized strategy sessions to align web infrastructure with evolving business goals. Performance audits covering speed optimization, SEO, and UX heuristics. Guidance on feature expansions, third-party integrations (payment gateways, APIs), and modern tech stacks.</small></p>


                    <h5><b> 🔹 Uptime & Health Maintenance</b></h5>
                    <p className='mb-2'><small>Monitoring services to track uptime, server health, and page-level errors (e.g., 404s, 500s).</small></p>
                    <p className='mb-3'><small>Monthly reports detailing site performance metrics and recommendations.</small></p>
                    <h5><b> 🔹 Performance Optimization</b></h5>
                    <p className='mb-3'><small>Speed audits using tools like Google PageSpeed Insights and GTmetrix.

                        Caching strategies, image optimization, lazy loading, and code minification.

                        Ongoing tweaks to maintain fast load times and high-performance benchmarks.</small></p>

         <h5><b> 🔹 Content & Feature Updates</b></h5>
                                        <p className='mb-2'><small>Streamlined workflows to publish blog posts, product updates, event listings, media assets, and more.</small></p>
<p className='mb-2'><small>Frontend tweaks or backend enhancements on-demand (e.g., new forms, user dashboards, third-party integrations).</small></p>
<p><small>Hands-on training sessions to empower your team to manage content independently.</small></p>
                </div>
                <br />
                <Develop />

                <div className="album py-0">
                    <div className="container">
                        <h1 style={{ color: "grey" }}> Reviews from Our Hon'ble Clients</h1>
                    </div>
                </div>
                <Reviews />
            </div>


        </div>
    )
}

export default Support